module.exports = __webpack_public_path__ + "media/assets/images/blog/default_image-small-dd3e6b1ce316c90e441f0431f223468d.jpg";